let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hOsjc")).then(() => parcelRequire('92Mdh'));